<template>
  <div class="notice">
    <div>
      <span class="back" @click="routerTo('/pcpage/skill/skilllist')">
        <img src="../img/arrow.png" alt="" /> 摄影技巧
      </span>
    </div>
    <div class="content">
      <div class="title">短视频制作技巧</div>
      <div class="word">
        <div >
          <!-- <p
            style="margin-top:0;margin-bottom:0;text-indent:32px;line-height:27px;background:rgb(255,255,255)"
          >
            <span style=";font-family:微软雅黑;font-size:16px"
              >视频制作小贴士</span
            >
          </p> -->
          <p
            style="margin-top:0;margin-bottom:0;text-indent:32px;line-height:27px;background:rgb(255,255,255)"
          >
            <strong
              ><span style=";font-family:微软雅黑;font-size:16px"
                >手机端剪映使用方法：</span
              ></strong
            >
          </p>
          <p
            style="margin-top:0;margin-bottom:0;text-indent:32px;line-height:27px;background:rgb(255,255,255)"
          >
            <span style=";font-family:微软雅黑;font-size:16px"
              ><span style="font-family:微软雅黑"
                >首先在手机应用商店搜索剪映</span
              ><span style="font-family:微软雅黑"
                >app并进行下载，安装完成后打开软件：</span
              ></span
            >
          </p>
          <p
            style="margin-top:0;margin-bottom:0;text-indent:32px;line-height:27px;background:rgb(255,255,255)"
          >
            <span style=";font-family:微软雅黑;font-size:16px">1.点击打开</span
            ><a href="https://www.liqucn.com/rj/1191626.shtml"
              ><span style=";font-family:微软雅黑;font-size:16px">剪映</span></a
            ><span style=";font-family:微软雅黑;font-size:16px"
              >APP，点击开始创作选择想要编辑的</span
            ><a href="https://www.liqucn.com/rj/tag/shipin/"
              ><span style=";font-family:微软雅黑;font-size:16px">视频</span></a
            ><span style=";font-family:微软雅黑;font-size:16px">或者</span
            ><a href="https://www.liqucn.com/rj/tag/tupian/"
              ><span style=";font-family:微软雅黑;font-size:16px">图片</span></a
            ><span style=";font-family:微软雅黑;font-size:16px"
              ><span style="font-family:微软雅黑">之后点击</span
              >“添加到项目”。</span
            >
          </p>
          <p
            style="margin-top:0;margin-bottom:0;text-indent:32px;text-align:center;line-height:27px;background:rgb(255,255,255)"
          >
            <img
              src="../img/skill/20210906-1630910887398696.jpg"
              title="20210906-1630910887398696.jpg"
              alt="wps101.jpg"
            /><span style=";font-family:微软雅黑;font-size:16px">&nbsp;</span>
          </p>
          <p
            style="margin-top:0;margin-bottom:0;text-indent:32px;text-align:center;line-height:27px;background:rgb(255,255,255)"
          >
            <img
              src="../img/skill/20210906-1630910899210172.jpg"
              title="20210906-1630910899210172.jpg"
              alt="wps102.jpg"
            /><span style=";font-family:微软雅黑;font-size:16px">&nbsp;</span>
          </p>
          <p
            style="margin-top:0;margin-bottom:0;text-indent:32px;line-height:27px;background:rgb(255,255,255)"
          >
            <span style=";font-family:微软雅黑;font-size:16px"
              >2.然后进入到</span
            ><a href="https://www.liqucn.com/rj/tag/shipinbianji/"
              ><span style=";font-family:微软雅黑;font-size:16px"
                >视频编辑</span
              ></a
            ><span style=";font-family:微软雅黑;font-size:16px"
              ><span style="font-family:微软雅黑"
                >软件，在视频编辑软件的下方可以选择自己想要进行的操作进行操作。加音乐，加贴纸，增加转场</span
              >........</span
            >
          </p>
          <p
            style="margin-top:0;margin-bottom:0;text-indent:32px;text-align:center;line-height:27px;background:rgb(255,255,255)"
          >
            <img
              src="../img/skill/20210906-1630910910201209.jpg"
              title="20210906-1630910910201209.jpg"
              alt="wps103.jpg"
            /><span style=";font-family:微软雅黑;font-size:16px">&nbsp;</span>
          </p>
          <p
            style="margin-top:0;margin-bottom:0;text-indent:32px;text-align:center;line-height:27px;background:rgb(255,255,255)"
          >
            <img
              src="../img/skill/20210906-1630910921931768.jpg"
              title="20210906-1630910921931768.jpg"
              alt="wps104.jpg"
            /><span style=";font-family:微软雅黑;font-size:16px">&nbsp;</span>
          </p>
          <p
            style="margin-top:17px;margin-bottom:17px;text-indent:32px;line-height:27px;background:rgb(255,255,255)"
          >
            <span style=";font-family:微软雅黑;font-size:16px"
              >3.之后视频编辑成自己想要的样子过后可以点击页面中间的播放按钮观看成片效果。若是多个视频可以在视频衔接点处点击增加转场特效。</span
            >
          </p>
          <p
            style="margin-top:17px;margin-bottom:17px;text-indent:32px;text-align:center;line-height:27px;background:rgb(255,255,255)"
          >
            <img
              src="../img/skill/20210906-1630910942791827.jpg"
              title="20210906-1630910942791827.jpg"
              alt="wps105.jpg"
            /><span style=";font-family:微软雅黑;font-size:16px">&nbsp;</span>
          </p>
          <p
            style="margin-top:17px;margin-bottom:17px;text-indent:32px;text-align:center;line-height:27px;background:rgb(255,255,255)"
          >
            <img
              src="../img/skill/20210906-1630910965154235.jpg"
              title="20210906-1630910965154235.jpg"
              alt="wps106.jpg"
            /><span style=";font-family:微软雅黑;font-size:16px">&nbsp;</span>
          </p>
          <p
            style="margin-top:17px;margin-bottom:17px;text-indent:32px;line-height:27px;background:rgb(255,255,255)"
          >
            <span style=";font-family:微软雅黑;font-size:16px"
              >4.最后完成过后点击右上角“导出”按钮导出到手机相册，</span
            ><span style=";font-family:微软雅黑;font-size:16px">&nbsp;</span>
          </p>
          <p
            style="margin-top:17px;margin-bottom:17px;line-height:27px;background:rgb(255,255,255)"
          >
            <span style=";font-family:微软雅黑;font-size:16px">&nbsp;</span
            ><strong
              ><span style=";font-family:微软雅黑;font-size:16px"
                >电脑端剪映使用方法：</span
              ></strong
            >
          </p>
          <p>
            <span style=";font-family:微软雅黑;font-size:16px"
              >相信许多小伙伴都有使用过手机端的剪映，剪映这款软件可以说是目前市面上最火热的短</span
            ><a href="http://www.xitongzhijia.net/zt/52180.html"
              ><span style=";font-family:微软雅黑;font-size:16px"
                >视频剪辑软件</span
              ></a
            ><span style=";font-family:微软雅黑;font-size:16px"
              ><span style="font-family:微软雅黑">了。最近剪映</span
              ><span style="font-family:微软雅黑"
                >Windows电脑版也随之推出，许多小伙伴并不知道怎么使用这款软件，下面小编就为大家带来了剪映Windows专业版的入门教程，快来学习吧！</span
              ></span
            >
          </p>
          <p>
            <strong
              ><span
                style="font-family: 微软雅黑;font-size: 11px"
                ><span style="font-family:微软雅黑"> 剪映</span
                ><span style="font-family:微软雅黑"
                  >Windows版入门教程：</span
                ></span
              ></strong
            >
          </p>
          <p>
            <span
              style=";font-family:微软雅黑;font-size:11px"
            >
              <span style="font-family:微软雅黑"
                >1、首先，我们下载剪映Windows专业版，并且安装。</span
              ></span
            >
          </p>
          <p>
            <span
              style=";font-family:微软雅黑;font-size:11px"
            >
              <span style="font-family:微软雅黑"
                >2、打开剪映Windows专业版，点击开始创作。</span
              ></span
            >
          </p>
          <p style="text-align:center;">
            <img
              src="../img/skill/20210906-1630910982683497.jpg"
              title="20210906-1630910982683497.jpg"
              alt="wps107.jpg"
            /><span style=";font-family:宋体;font-size:11px">&nbsp;</span>
          </p>
          <p>
            <span
              style=";font-family:微软雅黑;font-size:11px"
            >
              <span style="font-family:微软雅黑"
                >3、将我们需要剪辑的视频导入到软件中。</span
              ></span
            >
          </p>
          <p style="text-align:center;">
            <img
              src="../img/skill/20210906-1630910997145075.jpg"
              title="20210906-1630910997145075.jpg"
              alt="wps108.jpg"
            /><span style=";font-family:宋体;font-size:11px">&nbsp;</span>
          </p>
          <p >
            <span
              style=";font-family:微软雅黑;font-size:11px"
            >
              <span style="font-family:微软雅黑"
                >4、将导入的视频文件拖拽到视频编辑区。</span
              ></span
            >
          </p>
          <p style="text-align:center;">
            <img
              src="../img/skill/20210906-1630911014613790.jpg"
              title="20210906-1630911014613790.jpg"
              alt="wps109.jpg"
            /><span style=";font-family:宋体;font-size:11px">&nbsp;</span>
          </p>
          <p style="text-align:center;">
            <img
              src="../img/skill/20210906-1630911029955884.jpg"
              title="20210906-1630911029955884.jpg"
              alt="wps110.jpg"
            /><span style=";font-family:宋体;font-size:11px">&nbsp;</span>
          </p>
          <p>
            <span
              style=";font-family:微软雅黑;font-size:11px"
            >
              <span style="font-family:微软雅黑"
                >5、这个时候我们就可以对视频进行创作了，可以根据自己的需求在视频中添加素材，软件为用户提供了一些默认素材，用户也可以根据自己的需求导入本地的素材。</span
              ></span
            >
          </p>
          <p style="text-align:center;">
            <img
              src="../img/skill/20210906-1630911044830200.jpg"
              title="20210906-1630911044830200.jpg"
              alt="wps111.jpg"
            /><span style=";font-family:宋体;font-size:11px">&nbsp;</span>
          </p>
          <p>
            <span
              style=";font-family:微软雅黑;font-size:11px"
            >
              <span style="font-family:微软雅黑"
                >6、点击音频，用户可以根据自己的需求添加音频文件，还可以登录自己的抖音账号，导入抖音收藏的音频文件。</span
              ></span
            >
          </p>
          <p style="text-align:center;">
            <img
              src="../img/skill/20210906-1630911057982308.jpg"
              title="20210906-1630911057982308.jpg"
              alt="wps112.jpg"
            /><span style=";font-family:宋体;font-size:11px">&nbsp;</span>
          </p>
          <p>
            <span
              style=";font-family:微软雅黑;font-size:11px"
            >
              <span style="font-family:微软雅黑"
                >7、点击文本，用户可以根据需求添加视频文本，软件可以通过视频、音频文件识别人声，并且自动在时间轴上生成字幕文本。</span
              ></span
            >
          </p>
          <p style="text-align:center;">
            <img
              src="../img/skill/20210906-1630911082276874.jpg"
              title="20210906-1630911082276874.jpg"
              alt="wps113.jpg"
            /><span style=";font-family:宋体;font-size:11px">&nbsp;</span>
          </p>
          <p>
            <span
              style=";font-family:微软雅黑;font-size:11px"
            >
              <span style="font-family:微软雅黑"
                >8、点击贴纸，用户可以选择软件自带的贴纸添加到自己的视频中。</span
              ></span
            >
          </p>
          <p style="text-align:center;">
            <img
              src="../img/skill/20210906-1630911099112684.jpg"
              title="20210906-1630911099112684.jpg"
              alt="wps114.jpg"
            /><span style=";font-family:宋体;font-size:11px">&nbsp;</span>
          </p>
          <p>
            <span
              style=";font-family:微软雅黑;font-size:11px"
            >
              <span style="font-family:微软雅黑"
                >9、点击特效，用户可以选择软件自带的特效效果给自己的视频添加特效。</span
              ></span
            >
          </p>
          <p style="text-align:center;">
            <img
              src="../img/skill/20210906-1630911115228657.jpg"
              title="20210906-1630911115228657.jpg"
              alt="wps115.jpg"
            /><span style=";font-family:宋体;font-size:11px">&nbsp;</span>
          </p>
          <p>
            <span
              style=";font-family:微软雅黑;font-size:11px"
            >
              <span style="font-family:微软雅黑"
                >10、点击转场，用户可以选择视频切换时候的特效效果。</span
              ></span
            >
          </p>
          <p style="text-align:center;">
            <img
              src="../img/skill/20210906-1630911127584799.jpg"
              title="20210906-1630911127584799.jpg"
              alt="wps116.jpg"
            /><span style=";font-family:宋体;font-size:11px">&nbsp;</span>
          </p>
          <p>
            <span
              style=";font-family:微软雅黑;font-size:11px"
            >
              <span style="font-family:微软雅黑"
                >11、点击滤镜，用户可以为自己的视频文件整体或者某段添加滤镜效果。</span
              ></span
            >
          </p>
          <p style="text-align:center;">
            <img
              src="../img/skill/20210906-1630911149119306.jpg"
              title="20210906-1630911149119306.jpg"
              alt="wps117.jpg"
            /><span style=";font-family:宋体;font-size:11px">&nbsp;</span>
          </p>
          <p>
            <span
              style=";font-family:微软雅黑;font-size:11px"
            >
              <span style="font-family:微软雅黑"
                >12、点击调节，用户可以自定义调节视频效果。</span
              ></span
            >
          </p>
          <p style="text-align:center;">
            <img
              src="../img/skill/20210906-1630911168264923.jpg"
              title="20210906-1630911168264923.jpg"
              alt="wps118.jpg"
            /><span style=";font-family:宋体;font-size:11px">&nbsp;</span>
          </p>
          <p>
            <span
              style=";font-family:微软雅黑;font-size:11px"
            >
              <span style="font-family:微软雅黑"
                >13、用户制作完视频之后，点击导出，可以设置视频保存的位置和分辨率等相关参数，还可以设置保存文件的格式。</span
              ></span
            >
          </p>
          <p style="text-align:center;">
            <img
              src="../img/skill/20210906-1630911182117733.jpg"
              title="20210906-1630911182117733.jpg"
              alt="wps119.jpg"
            /><span style=";font-family:宋体;font-size:11px">&nbsp;</span>
          </p>
          <p>
            <span
              style=";font-family:微软雅黑;font-size:11px"
            >
              <span style="font-family:微软雅黑"
                >14、点击导出，等待导出完成视频就制作好了。</span
              ></span
            >
          </p>
          <p style="text-align:center;">
            <img
              src="../img/skill/20210906-1630911194868529.jpg"
              title="20210906-1630911194868529.jpg"
              alt="wps120.jpg"
            /><span style=";font-family:宋体;font-size:11px">&nbsp;</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "notice",
  data: function() {
    return {};
  },
  methods: {
    routerTo(path) {
      this.$router.push(path);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.notice {
  width: 1200px;
  margin: 50px auto 50px;
  text-align: center;
  font-size: 20px;
  text-align: left;
  .back {
    font-size: 24px;
    color: #0b0b0b;
    font-weight: bold;
    cursor: pointer;
    img {
      vertical-align: middle;
      margin-top: -4px;
    }
  }
  .content {
    width: 1200px;
    background-color: #fff;
    padding: 0 40px 70px;
    text-align: center;
    margin-top: 40px;
    box-sizing: border-box;
    .title {
      position: relative;
      top: -35px;
      width: 405px;
      height: 70px;
      line-height: 65px;
      margin: auto;
      background-image: linear-gradient(0deg, #746bef 0%, #728bf9 100%);
      border-radius: 35px;
      text-align: center;
      font-size: 50px;
      color: #fff;
      font-weight: bold;
      &:before {
        position: absolute;
        left: -60px;
        top: 15px;
        content: "";
        display: inline-block;
        width: 60px;
        height: 60px;
        background-image: url(../img/left.png);
        background-repeat: no-repeat;
      }
      &:after {
        position: absolute;
        right: -80px;
        top: 15px;
        content: "";
        display: inline-block;
        width: 60px;
        height: 60px;
        background-image: url(../img/right.png);
        background-repeat: no-repeat;
      }
    }
    p {
      text-align: left;
      font-size: 28px;
      color: #0b2ab0;
      line-height: 1.4;
    }
    .p_left {
      text-indent: 0;
    }
    h2 {
      font-size: 28px;
      font-weight: bold;
      color: #0b2ab0;
      text-align: left;
      margin-top: 35px;
    }
    h3 {
      font-size: 28px;
      color: #0b2ab0;
      text-align: left;
      margin-top: 20px;
      text-indent: 1em;
    }
    .word {
      font-size: 16px;
      font-family: "Microsoft Yahei" !important;
      color: #666;
      line-height: 40px;
      strong {
        font-weight: bold;
      }
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 20px;
      }
      img {
        max-width: 554px !important;
      }
      p {
        line-height: 1.4;
        margin-bottom: 5px;
        color: #0b2ab0;
        word-break: break-all;
        span {
          font-size: 16px;
          font-family: "Microsoft Yahei";
        }
        a {
          color: #0b2ab0;
        }
        strong {
          font-weight: bold;
        }
        em {
          font-style: italic;
        }
        img {
          max-width: 554px !important;
          text-indent: 0;
          margin-bottom: 0px;
        }
        video {
          margin-left: -2em;
        }
        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
